export const backendTechStack = [
  {
    img: "https://taher-ahmed.vercel.app/nodejs-icon.svg",
    name: "Nde.js",
  },
  {
    img: "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
    name: "Express.js",
  },
  {
    img: "https://taher-ahmed.vercel.app/mongodb.svg",
    name: "MongoDB",
  },
  {
    img: "https://cdn.dribbble.com/users/528264/screenshots/3140440/firebase_logo.png",
    name:"Firebase"
  },
  {
    img: "https://taher-ahmed.vercel.app/postman-icon.svg",
    name: "Postman",
  },
]